/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collapse } from '@mui/material';
import React, { FC, useState } from 'react';
import { StyledNavBarIcon } from '../BaseNavbar.styles';
import { StyledTooltip } from './NavLink.styles';
import {
  Header,
  IconTextContainer,
  StyledDropDownIcon,
  StyledList,
  StyledText,
} from './NavLinkList.styles';
interface Props {
  'data-testid'?: string;
  text: string;
  open?: boolean;
  children: React.ReactNode;
  icon?: string;
  navOpen?: boolean;
  onClick?: () => void;
  tooltipText?: string;
  isActive?: boolean;
}

export const NavLinkList: FC<Props> = ({
  text,
  open,
  children,
  icon,
  navOpen,
  onClick,
  tooltipText,
  isActive,
  ...props
}) => {
  const [navTooltip, setNavTooltip] = useState(false);
  const [navTooltipRoot, setNavTooltipRoot] = useState<any>(null);

  return (
    <li>
      <Header
        data-testid={props['data-testid']}
        onClick={onClick}
        open={open}
        $isActive={isActive}
      >
        <IconTextContainer>
          {icon && (
            <StyledNavBarIcon
              className={icon}
              size="20px"
              ref={setNavTooltipRoot}
              onMouseOver={() => setNavTooltip(true)}
              onMouseOut={() => setNavTooltip(false)}
            />
          )}
          <StyledText navOpen={navOpen}>{text}</StyledText>
        </IconTextContainer>
        {navOpen && <StyledDropDownIcon dropDownOpen={open} />}
      </Header>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <StyledList>{children}</StyledList>
      </Collapse>
      {navTooltip && !navOpen && tooltipText && (
        <StyledTooltip
          text={tooltipText}
          variant="left"
          root={navTooltipRoot}
        />
      )}
    </li>
  );
};
